import { Injectable, EventEmitter } from '@angular/core';
import { ConfigService } from '@ngx-config/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { TranslateService } from 'shared/translate';
import { BaseService } from './base.service';
import { ResultadoOperacao } from 'shared/entities/resultadooperacao.entity';
import { Mensagem } from 'shared/entities/mensagem.entity';
import { ItemLista } from 'shared/entities/itemlista.entity';
import { LoginOperador } from 'shared/entities/loginoperador.entity';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UsuarioAutenticado } from 'shared/entities/usuarioautenticado.entity';
import { ResultadoConsulta } from 'shared/entities/resultadoconsulta.entity';
import { UsuarioConta } from 'shared/entities/usuarioconta.entity';
import { TrocaSenha } from 'shared/entities/trocasenha.entity';
import { enumTransacao } from 'shared/domains/enumtransacao.enum';
import { enumTipoAcao } from 'shared/domains/enumtipoacao.enum';
import { enumTipoPessoa } from 'shared/domains/enumtipopessoa.enum';
import { Usuario } from 'shared/entities/usuario.entity';
import { TrocaSenhaToken } from 'shared/entities/trocasenhatoken.entity';


@Injectable()

export class AutenticacaoService extends BaseService {


    public TokenName: string = "auth_token_wooriib";
    public Logado: boolean = false;
    public MensagemAlerta: string = null;
    public Carregando: boolean = false;
    public DadoAutenticacao: UsuarioAutenticado;
    private ChaveOperacaoUnica: string = null;

    constructor(private http: HttpClient, readonly config: ConfigService) {
        super(config)
        this.apiUrl += 'Autenticacao';
    }
    private autenticarSubject: Subject<any> = new Subject<any>();
    PreencherAcesso(dadoautenticacao: UsuarioAutenticado): void {
        this.DadoAutenticacao = dadoautenticacao;
        sessionStorage.setItem(this.TokenName, dadoautenticacao.Token);
        this.Logado = true;
        this.autenticarSubject.next();
    }

    VerificarAutencicacao(): Observable<any> {
        return this.autenticarSubject.asObservable();
    }

    ValidarToken(): Observable<boolean> {
        var Token = sessionStorage.getItem(this.TokenName);
        if (Token) {
            return this.http.get(this.apiUrl + "/ValidarToken?Token=" + Token)
                .pipe(
                    map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));
        }
        else {
            return new Observable<boolean>((observer) => {
                observer.next(false);
                observer.complete();
            });
        }
    };


    CarregarDadoToken(): Observable<UsuarioAutenticado> {
        var url: string = this.apiUrl + "/CarregarUsuario";
        return this.http.get(url)
            .pipe(
                map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));
    }



    LogOut(): Observable<void> {
        var url: string = this.apiUrl + "/Logout";
        var retorno = this.http.get<void>(url).pipe(
            map(response => sessionStorage.removeItem(this.TokenName)));
        return retorno;
    }

    Logar(item: LoginOperador): Observable<ResultadoOperacao<UsuarioAutenticado>> {
        var url: string = this.apiUrl + "/Login";
        return this.http.post<ResultadoOperacao<UsuarioAutenticado>>(url, item)
            .pipe(
                map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));
    }

    PossuiToken(): boolean {
        var Token = sessionStorage.getItem(this.TokenName);
        if (Token)
            return true;
        else
            return false;
    }

    ValidarConta(NumeroConta: string): Observable<ResultadoConsulta<UsuarioConta>> {
        var url: string = this.apiUrl + "/ValidarConta?Conta=" + NumeroConta;
        return this.http.get<ResultadoOperacao<UsuarioConta>>(url)
            .pipe(
                map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));

    }

    AlterarSenha(item: TrocaSenha): Observable<ResultadoOperacao<TrocaSenha>> {
        var url: string = this.apiUrl + "/AlterarSenha";
        return this.http.post<ResultadoOperacao<TrocaSenha>>(url, item)
            .pipe(
                map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));

    }

    AlterarSenhaToken(item: TrocaSenhaToken): Observable<ResultadoOperacao<TrocaSenhaToken>> {
        var url: string = this.apiUrl + "/AlterarSenhaToken";
        return this.http.post<ResultadoOperacao<TrocaSenhaToken>>(url, item)
            .pipe(
                map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora)));

    }

    IniciarAtivacaoToken(): Observable<ResultadoOperacao<string>> {
        var url: string = this.apiUrl + "/IniciarAtivacaoToken";
        return this.http.get<any>(url, { observe: 'response' })
            .pipe(
                tap(res => {

                    if (res instanceof HttpResponse) {
                        var token = res.headers.get('uniqueoperationtoken');
                        if (token)
                            this.ChaveOperacaoUnica = token;
                    }
                })
                , map(response => JSON.parse(JSON.stringify(response.body), this.AjustarDataHora))
            );
    }

    ConcluirAtivacaoToken(Token: string): Observable<ResultadoOperacao<string>> {
        var url: string = this.apiUrl + "/ConcluirAtivacaoToken";

        const headerSettings: { [name: string]: string | string[] } = {};

        headerSettings["uniqueoperationtoken"] = this.ChaveOperacaoUnica;

        const newHeader = new HttpHeaders(headerSettings);

        return this.http.post<any>(url, Token, {
            headers: newHeader,
            observe: 'response'
        }).pipe(
            tap(res => {

                if (res instanceof HttpResponse) {
                    var token = res.headers.get('uniqueoperationtoken');
                    if (token)
                        this.ChaveOperacaoUnica = token;
                }
            })
            , map(response => JSON.parse(JSON.stringify(response.body), this.AjustarDataHora))
        );
    }

    PossuiAcesso(Transacao: enumTransacao): boolean {
        //return true;
        return this.DadoAutenticacao.Funcionalidades.some(d => d == Transacao);
    }

    PossuirAcessoRemoto(Transacao: enumTransacao, ...Acao: enumTipoAcao[]): Observable<boolean> {
        let params = new HttpParams();
        var url: string = this.apiUrl + "/PossuirAcesso/" + Transacao.toString();
        if (Acao)
            Acao.forEach(d => {
                params = params.append("acao", d.toString());
            });
        return this.http.get<boolean>(url, { params: params });
    }

    RetornarAcoes(Transacao: enumTransacao): Observable<ItemLista[]> {
        let params = new HttpParams();
        var url: string = this.apiUrl + "/RetornarAcoes/" + Transacao.toString();
        return this.http.get<ItemLista[]>(url, { params: params });
    }

    ValidarMFA(Token: string): Observable<ResultadoOperacao<string>> {
        var url: string = this.apiUrl + "/ValidarMFA?Token=" + Token;
        return this.http.get<ResultadoOperacao<string>>(url);

    }

    ValidarPossuiAcaoTela(AcoesTela: ItemLista[], acao: enumTipoAcao) {
        return AcoesTela.some(d => d.Codigo == acao);

    }

    ConfirmarTermoIB(): Observable<ResultadoOperacao<UsuarioConta>> {
        var url: string = this.apiUrl + "/AcessarPixInformativo/3";
        return this.http.post<ResultadoOperacao<UsuarioConta>>(url, null);
    }

    ValidarOpenBanking(): Observable<boolean> {
        var url: string = this.apiUrl + "/ValidarConfirmacao/4";
        return this.http.post<boolean>(url, null);
    }

    ConfirmarOpenBanking(): Observable<ResultadoOperacao<UsuarioConta>> {
        var url: string = this.apiUrl + "/AcessarPixInformativo/4";
        return this.http.post<ResultadoOperacao<UsuarioConta>>(url, null);
    }

    ValidarPix(): Observable<boolean> {
        var url: string = this.apiUrl + "/ValidarConfirmacao/1";
        return this.http.post<boolean>(url, null);
    }

    ConfirmarPix(): Observable<ResultadoOperacao<UsuarioConta>> {
        var url: string = this.apiUrl + "/AcessarPixInformativo/1";
        return this.http.post<ResultadoOperacao<UsuarioConta>>(url, null);
    }


    RetornarDocumentoFormatado(): string {
        var documento: string = null;
        if (this.DadoAutenticacao) {
            documento = this.DadoAutenticacao.CPFCNPJ;
            documento = documento.replace(/[^\d]/g, "");

            if (this.DadoAutenticacao.TipoPessoa == enumTipoPessoa.Fisica) {
                documento = documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            }
            if (this.DadoAutenticacao.TipoPessoa == enumTipoPessoa.Fisica) {
                documento = documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            }
        }
        return documento;
    }
    
    RetornarTipoPessoaIsJuridica(): boolean {
        if (this.DadoAutenticacao)
            return this.DadoAutenticacao.TipoPessoa != enumTipoPessoa.Fisica;
        
        return false;
    }
    
    getSpkiDer(spkiPem) {
        const pemHeader = "-----BEGIN PUBLIC KEY-----";
        const pemFooter = "-----END PUBLIC KEY-----";
        var pemContents = spkiPem.substring(
            pemHeader.length,
            spkiPem.length - pemFooter.length
        );
        var binaryDerString = window.atob(pemContents);
        return this.str2ab(binaryDerString);
    }

    async importPublicKey(spkiPem) {
        return await window.crypto.subtle.importKey(
            "spki",
            this.getSpkiDer(spkiPem),
            {
                name: "RSA-OAEP",
                hash: "SHA-256",
            },
            true,
            ["encrypt"]
        );
    }

    async encryptRSA(key, plaintext) {
        let encrypted = await window.crypto.subtle.encrypt(
            {
                name: "RSA-OAEP",
            },
            key,
            plaintext
        );
        return encrypted;
    }

    str2ab(str) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    ab2str(buf) {
        return String.fromCharCode.apply(null, new Uint8Array(buf));
    }

    async encrypt(plaintext, publicKey): Promise<string> {
        const pub = await this.importPublicKey(publicKey);
        const encrypted = await this.encryptRSA(
            pub,
            new TextEncoder().encode(plaintext)
        );
        const encryptedBase64 = window.btoa(this.ab2str(encrypted));
        return encryptedBase64;
    }


}